import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaSearch,FaTrash} from "react-icons/fa";
import { ProductConsumer } from "../../context";
import DeleteGallery from "./DeleteGallery";

export default function AdminProduct(product) {
	return (
		<ProductConsumer>
			{(value) => {
				const {setSingleProduct,handleModalOpen } = value;
				
				

				return (
					<AdminProductWrapper className="col-10 mx-auto col-sm-8 col-md-6 col-lg-4 my-3">
						<div className="card">
							<div className="img-container">
								<div className="product-icons">
									<Link
										to={`/adminproductupdate/${product.product.nr}`}
										onClick={() => setSingleProduct(product.product.nr)}
									>
										<FaSearch className="icon" />
									</Link>
									<FaTrash className="icon" onClick={()=> handleModalOpen(product.product)} />
								</div>
							</div>
							<div className="card-body ">
								<p className="mb-0">
									<span className="produktnr text-main">{product.product.nr}.</span>
									{product.product.pName}
								</p>
								<div className="d-flex justify-content-between">
									<p className="mb-2 text-topping"> {product.product.topping}</p>
									<p className="mb-0 text-main">{product.product.price}Kr</p>
								</div>
							</div>
							<DeleteGallery></DeleteGallery>
						</div>

					</AdminProductWrapper>
				);
			}}
		</ProductConsumer>
	);
}

const AdminProductWrapper = styled.div`
	.card {
		box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.3);
		transition: var(--mainTransition);
		height: 100%;
	}
	.card:hover {
		box-shadow: 7px 10px 5px 0px rgba(0, 0, 0, 0.5);
		cursor: pointer;
	}
	.card-img-top {
		transition: var(--mainTransition);
	}
	.card:hover .card-img-top {
		transform: scale(1.10);
		opacity: 0.2;
	}
	.img-container {
		position: relative;
	}

	.product-icons {
		transition: var(--mainTransition);
		position: absolute;
		top: 90%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 0;
	}
	.icon {
		font-size: 2.5rem;
		margin: 1rem;
		padding: 0.5rem;
		color: var(--primaryColor);
		background: var(--mainBlack);
		border-radius: 0.5rem;
	}

	.card:hover .product-icons {
		opacity: 1;
	}
	.card-body {
		font-weight: bold;
		letter-spacing: 2px;
		text-transform: uppercase;
	}
	.text-topping {
		font-size: 0.80rem;
		font-weight: bold;
		font-style: italic;
	}
`;
